import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconVideo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M480.754 256L72.906 499.356V12.644z",
		fontWeight: 400,
		fontFamily: "sans-serif",
		overflow: "visible",
		fill: "currentColor",
		paintOrder: "fill markers stroke"
	})
});
export { SvgIconVideo as ReactComponent };
